import script from "./paymentPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./paymentPopup.vue?vue&type=script&setup=true&lang=ts"

import "./paymentPopup.vue?vue&type=style&index=0&id=e354763c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e354763c"]])

export default __exports__